import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {ClickableDiv} from '@Components/clickable-div';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import styles from './suggestion-pill.module.scss';
import type {SuggestionPillProps} from '@Components/template-submission-flow/components/suggestion-pill/suggestion-pill.types';
import {SuggestionPillType} from '@Components/template-submission-flow/components/suggestion-pill/suggestion-pill.types';

export function SuggestionPill({
  id,
  text,
  onClick,
  type = SuggestionPillType.SECONDARY,
  className = '',
  isSelected = false,
  hasRightIcon = '',
  rightIconClassName = '',
  textClassName = '',
  isTextBold = true,
  hasLeftIcon = '',
  leftIconClassName = '',
  textSize = TextSize.XXSMALL,
  hasHover = false,
}: SuggestionPillProps): ReactElement {
  const onClickPill = (): void => {
    onClick(text, id);
  };

  const getLeftIconForPill = (): ReactElement | null => {
    if (hasLeftIcon) {
      return <Icon icon={hasLeftIcon} size={IconSize.SIZE_ICON_16} className={`${leftIconClassName} spacing-p-r-1 content-body`} />;
    }

    return null;
  };

  const getRightIconForPill = (): ReactElement | null => {
    if (hasRightIcon) {
      return <Icon icon={hasRightIcon} size={IconSize.SIZE_ICON_16} className={`${rightIconClassName} spacing-p-l-1 content-body`} />;
    }

    return null;
  };

  const getClassNameForPill = (): string => {
    if (isSelected) {
      return styles.selected;
    }

    let className = '';
    if (type === SuggestionPillType.NEUTRAL) {
      className = styles.neutral;
    } else {
      className = styles.secondary;
    }

    if (hasHover) {
      className = `${className} ${styles.hover}`;
    }

    return className;
  };

  return (
    <ClickableDiv className={`${className} ${styles.small} radius-round flex-row-align-center _fit-width _cursor-pointer ${getClassNameForPill()}`} onClick={onClickPill}>
      {getLeftIconForPill()}
      <Text val={text} size={textSize} className={`${textClassName} content-body`} bold={isTextBold} />
      {getRightIconForPill()}
    </ClickableDiv>
  );
}
